import { ICommunity } from "@sp-crm/core";
import { ContentFull, ContentHeader } from "components/layout";
import { Select } from "components/ui/select";
import * as React from "react";
import { CommunityInboundReferrals } from "./community-inbound-referrals";
import { CommunityOutboundReferrals } from "./community-outbound-referrals";

interface CommunityReferralsProps {
    community: ICommunity;
}

export const CommunityReferrals: React.FC<CommunityReferralsProps> = props => {
    const { community } = props;
    const [referralType, setReferralType] = React.useState("all");

    return (
        <div className="space-y-4">
            <div className="max-w-80">
                <Select
                    value={referralType}
                    label="Referral Type"
                    onChange={e => setReferralType(e.target.value)}>
                    <option value="all">Inbound & Outbound</option>
                    <option value="outbound">Outbound</option>
                    <option value="inbound">Inbound</option>
                </Select>
            </div>
            {referralType === "outbound" || referralType === "all" ? (
                <ContentFull>
                    <ContentHeader>Outbound Referrals</ContentHeader>
                    <CommunityOutboundReferrals communityId={community.id} />
                </ContentFull>
            ) : null}
            {referralType === "inbound" || referralType === "all" ? (
                <ContentFull>
                    <ContentHeader>Inbound Referrals</ContentHeader>
                    <CommunityInboundReferrals community={community} />
                </ContentFull>
            ) : null}
        </div>
    );
};
